import React, { Suspense, useEffect, useState } from "react";
import { Error } from "../../../commons/Messages/Messages";
import axios from "axios";
import { isAuthenticated } from "../../../commons/Auth/auth";
import InvoicesList from "../../../commons/Billing/Invoices/InvoicesList";
import AddInvoices from "../../../commons/Billing/Invoices/AddInvoices";
import SearchBarComp from "../../../commons/SearchBar/SearchBar";
import { generalErrorAlert } from "../../../commons/GeneralErrorAlert";
import PageToolbar from "../../../design-system/PageToolbar";
import { Segmented } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import RecurringInvoices from "../../../commons/Billing/Invoices/RecurringInvoices";
import { canAccounting } from "../../../commons/Billing/Invoices/invoiceErrors";
import { useIsMobile } from "../../../design-system/useMediaQuery";

import { useTranslation } from "react-i18next";

// ?view=recurring shows the recurring invoice templates (written with the same invoice form)
const Invoices = () => {
  const { t } = useTranslation("dashboard");
  const { t: ta } = useTranslation("accounting");
  const isMobile = useIsMobile();
  const location = useLocation();
  const history = useHistory();
  const showRecurring = canAccounting("Read");
  const view =
    showRecurring && new URLSearchParams(location.search).get("view") === "recurring"
      ? "recurring"
      : "invoices";
  const setView = v =>
    history.replace({
      pathname: location.pathname,
      search: v === "recurring" ? "?view=recurring" : ""
    });
  // /user/invoices?open=<id> (links from the assistant) shows that invoice
  const openId = new URLSearchParams(location.search).get("open");
  useEffect(() => {
    if (openId) history.replace(`/invoices/details/${openId}`);
  }, [openId]);
  const [recurringReload, setRecurringReload] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize] = useState(15);
  const [searchText, setSearchText] = useState("");
  const [totalCount, setTotalCount] = useState("");
  const [data, setData] = useState([]);

  const getData = async () => {
    await axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/invoices/invoices/filters`,
        {
          serviceProvider: isAuthenticated()?.serviceProviderId,
          searchText,
          pageSize,
          pageNo: pageNo - 1
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      )
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          setData(res.data.data);
          setTotalCount(res.data.count);
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        generalErrorAlert(err);
      });
  };

  useEffect(() => {
    getData();

    return () => {};
  }, [searchText, pageNo]);

  const handleSearch = value => {
    setSearchText(value);
    setPageNo(1);
  };

  return (
    <div className="invoices-page">
      {showRecurring ? (
        <Segmented
          block={isMobile}
          style={{ marginBottom: 12 }}
          value={view}
          onChange={setView}
          options={[
            { value: "invoices", label: ta("Invoices") },
            { value: "recurring", label: ta("Recurring invoices") }
          ]}
        />
      ) : null}
      {view === "recurring" ? (
        <>
          <PageToolbar
            actions={
              <Suspense fallback={<div>{t("Loading...")}</div>}>
                <AddInvoices
                  defaultRepeat
                  buttonText="New recurring invoice"
                  updateParent={getData}
                  onRecurringSaved={() => setRecurringReload(n => n + 1)}
                />
              </Suspense>
            }
          />
          <RecurringInvoices reloadKey={recurringReload} />
        </>
      ) : (
        <>
          <PageToolbar
            filters={<SearchBarComp handleSearch={handleSearch} />}
            actions={
              <Suspense fallback={<div>{t("Loading...")}</div>}>
                <AddInvoices updateParent={getData} onRecurringSaved={() => setView("recurring")} />
              </Suspense>
            }
          />
          <InvoicesList
            totalCount={totalCount}
            data={data}
            updateParent={getData}
            pageNo={pageNo}
            pageSize={pageSize}
            setPageNo={setPageNo}
          />
        </>
      )}
    </div>
  );
};

export default Invoices;
